import React from "react";
import clsx from "clsx";
import { getFileType, getSiteMedia, getSiteMedia2, getThumbFilename2, IImage } from "../../../models/Image";
import { FileType } from "../../../laco-common/base/models/IFile";
import ClientFirebase from "../../../laco-common/firebase/web";
import bg from "../../../assets/backgrounds/ImageLayersBg.png";
import MediaView from "./MediaView";
import "./ImageWithLayersBG.scss";

type ImageWithLayersBGProps = {
	url: string;
	className?: string;
	fullSize?: boolean;
};

export const ImageWithLayersBG: React.FC<ImageWithLayersBGProps> = (props: ImageWithLayersBGProps) => {
	const { url, className, fullSize } = props;
	const filename: string =
		url?.indexOf(ClientFirebase.storage._baseUrl) >= 0
			? (url || "")
					.substring(0, url.indexOf("?"))
					.replace("site%2Fsite_images%2F", "")
					.replace("Header%2F", "")
					.replace("Video%2F", "")
					.substring(ClientFirebase.storage._baseUrl.length)
			: url;
	const fileType: FileType = getFileType(filename);
	const nonImage: boolean = fileType !== FileType.IMAGE;
	const image: IImage = nonImage
		? getSiteMedia2({ filename, url, fileType }, "site_images", "Header", "Video")
		: getSiteMedia({ filename, url, fileType }, "site_images", "media");
	console.log("ImageWithLayersBG image:", image);
	return (
		<div
			className={clsx(
				"image-w-layers-bg-container position-relative",
				fullSize && "full-size",
				!fullSize && "nested",
				nonImage && "non-image",
				className
			)}
		>
			<img src={bg} className={clsx("image-w-layers-background", nonImage && "d-none")} />
			<MediaView
				image={image}
				imageWidth100Pct
				imageHeight100Pct
				isPercentage
				displayThumb={nonImage}
				displayEnlargeHover={nonImage}
			/>
		</div>
	);
};
